import { verifyNumberType } from "../types/index.types";

export const verifyNumberRequest = (payload,cb) => ({
    type: verifyNumberType.REQUEST,
    payload,
    cb
});

export const verifyNumberSuccess = (payload) => ({
    type: verifyNumberType.SUCCESS,
    payload,
});

export const verifyNumberFailure = (payload) => ({
    type: verifyNumberType.FAILURE,
    payload,
});
